// ⚠️⚠️⚠️⚠️ AUTO GENERATED FILE ⚠️⚠️⚠️⚠️ DO NOT EDIT ⚠️⚠️⚠️⚠️
import fetchGraphqlClient from '@workspace/nextjs_utils/src/fetchGraphqlClient';
import useQuery, { type QueryArgs } from '../../useQuery';
import { RewardCenterFaqQueryDocument, type RewardCenterFaqQuery, type RewardCenterFaqQueryVariables } from './RewardCenterFaqQuery';

export async function getRewardCenterFaqQueryClient(variables: RewardCenterFaqQueryVariables) {
  return fetchGraphqlClient<RewardCenterFaqQuery, RewardCenterFaqQueryVariables>(RewardCenterFaqQueryDocument, "RewardCenterFaqQuery", { variables });
}
export const useRewardCenterFaqQuery = (...args: QueryArgs<RewardCenterFaqQueryVariables>) => useQuery<RewardCenterFaqQuery, RewardCenterFaqQueryVariables>(getRewardCenterFaqQueryClient, ...args);